import { CurrentOpenMenu } from '@/pages/Search/SearchPage/types';
import FacetTypes from '@/types/search/enums/facetTypes';
import { FilterAction } from '@/types/SearchFacet';
import { QuickFilterName } from '@/utils/amplitude/analytics/searchPage';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { FacetOptionsPill } from '../FacetOptionsPill/FacetOptionsPill';

type Props = {
    currentOpenMenu?: CurrentOpenMenu;
    onMenuClose: () => void;
    onMenuOpen: (currentMenu: CurrentOpenMenu) => void;
};

export const MaterialsAndTechniquesPill = ({ currentOpenMenu, onMenuClose, onMenuOpen }: Props) => {
    const formatMessage = useAppFormatMessage();
    return (
        <FacetOptionsPill
            currentOpenMenu={currentOpenMenu}
            facetId={FacetTypes.MATERIALS_AND_TECHNIQUES_ID}
            filterActionChanged={FilterAction.MaterialsAndTechniquesChanged}
            filterActionRemoved={FilterAction.MaterialsAndTechniquesRemoved}
            label={formatMessage('search_facet_title_materialsAndTechniques')}
            onMenuClose={onMenuClose}
            onMenuOpen={onMenuOpen}
            openMenuId={CurrentOpenMenu.MaterialsAndTechniques}
            quickFilterName={QuickFilterName.MaterialsAndTechniques}
        />
    );
};
